const EVENT_CATEGORIES = [
  { key: "Vortrag", label: { de: "Vortrag", en: "Lecture" } },
  { key: "Workshop", label: { de: "Workshop", en: "Workshop" } },
  { key: "Get Together", label: { de: "Get Together", en: "Get-together" } },
  { key: "Seminar", label: { de: "Seminar", en: "Seminar" } },
  {
    key: "Symposium/Kolloquium",
    label: { de: "Symposium/Kolloquium", en: "Symposium/Colloquium" },
  },
  {
    key: "Informationsveranstaltung",
    label: { de: "Informationsveranstaltung", en: "Information event" },
  },
];

export default EVENT_CATEGORIES;
